module.exports = __webpack_public_path__ + "static/img/4areaB_4.3ba37c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_4.png
// module id = 1184
// module chunks = 1